'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;
var BfgBillersList = require('./billersList');


var SectionSendMoney = React.createClass({

    getInitialState () {

        var imgPath;

        if (this.props.locale == 'es')
            imgPath = 'img/icons/bfgIconMoney.jpg';
        else
            imgPath = "img/icons/bfgIconMoney_en.png";
        return {
            locale: this.props.locale, img: imgPath

        };
    },


    componentWillReceiveProps: function (nextProps) {


        if (!(this.props.locale == nextProps.locale)) {
            var imgPath;
            if (nextProps.locale == 'es')
                imgPath = 'img/icons/bfgIconMoney.jpg';
            else
                imgPath = "img/icons/bfgIconMoney_en.png";

            this.setState({
                img: imgPath
            });

        }
    },

    componentDidMount() {
        this.props.logPageView();
    },


    /**
     * @return {object}
     */
    render: function () {
        return (
            <section id="section6" className="content-section  about-section sectionPage">
                <div>
                    <div className="row">
                        <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
                            <div className="row">
                                <div className="col-xs-6 col-xs-offset-3 col-lg-4 col-lg-offset-4">
                                    <a href="https://www.barrimoneytransfer.com/mb/login" target="_blank"><img
                                        className="img-responsive" src={this.state.img}/>
                                        <p className="barriOnline"><FormatMessage locale={this.props.locale}
                                                                                  path="sendMoneyPage/sendMoneyOnline"/>
                                        </p></a>
                                </div>
                            </div>
                            <p><FormatMessage locale={this.props.locale} path="sendMoneyPage/sendMoneyDescription1"/>
                            </p><br/>
                            <p><FormatMessage locale={this.props.locale} path="sendMoneyPage/sendMoneyDescription2"/>
                            </p><br/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1"><p><FormatMessage
                            locale={this.props.locale} path="sendMoneyPage/sendMoneyDescription3"/><br/><br/></p></div>
                        <div className="col-sm-2 col-xs-2"></div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 col-md-offset-3 col-xs-12 col-sm-10 col-sm-offset-1"
                             id="bfgBillersList">
                            <BfgBillersList locale={this.props.locale}/>
                        </div>
                    </div>
                </div>
                <div>&nbsp;</div>
            </section>
        )
    }

});


module.exports = SectionSendMoney



// WEBPACK FOOTER //
// ./js/sectionSendMoney.js